import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  class: "col-1",
  style: {"text-align":"start"}
}
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "user-header" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Name", -1)
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Customer allocation", -1)
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1)
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-group row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Signature", -1)
const _hoisted_21 = ["height"]
const _hoisted_22 = { class: "form-group row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, null, -1)
const _hoisted_24 = { class: "col-sm-4" }

import Editor from "ckeditor5/ckeditor";
import { User} from '@/models';
import router from '@/router';
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'CognitoUserScreen',
  setup(__props) {

const height = ref(window.innerHeight);

const toasted = useToast();

const store = useStore();
const user = computed((): User => store.getters['usermanagement/selected']);
const getUser = async (email: string): Promise<User> => {
  return store.dispatch('usermanagement/getUser', email);
};
const setUser = async (user: User) => {
  return store.commit('usermanagement/setSelectedUser', user);
};
const saveUser = async (user: User): Promise<void> => {
  return store.dispatch('usermanagement/saveUser', user)
};
const getCognitouser = async (sub: any) => {
  return store.dispatch('sysadmin/getUser', sub)
}

const messageheight = computed(() => {
  return height.value - height.value * 0.30;
});

const signatureeditor = computed(() => {
  return Editor;
});

const signatureEditorConfig = computed(() => {
  return {
    toolbar: {
      items: ['heading', '|', 'bold', 'italic', 'link', '|', 'alignment:left', 'alignment:right', 'alignment:center',
        'alignment:justify', '|', 'bulletedList', 'numberedList', '|', 'insertTable', '|', 'outdent', 'indent',
        '|', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor', '|', 'undo', 'redo',],
    },
    licenseKey:
      "UUI3NHlwcFFOOXZpdFlqSFlhSUFYbWpCRHY4MnpuQWR1Mk95K2ZZWkxKSlVGclUrSFAvWEpmYndNRzNKLU1qQXlOREF4TURZPQ==",
    htmlSupport: {
      allow: [
        {
          name: /.*/,
          attributes: true,
          classes: true,
          styles: true,
        },
      ],
    },
  };
});

const signatureeditordata = computed({
  get: () => user.value.signature,
  set: (data: string) => {
    user.value.signature = data;
  }
});

onMounted(async () => {
  const cognitouser = await getCognitouser(router.currentRoute.value.params.sub);
  let email = '';
  if(cognitouser) {
    email = cognitouser.findAttributeValue('email');
    if(email){
      getUser(email)
      .then(async (u: User) => {
        if(u?.id) {
          setUser(u);
        }
        else {
          addNewUser();
        }
      })
      .catch((err: any) => {
        if(err?.response?.status === 404) {
          addNewUser();
        }
      })
    }
  }
});

const addNewUser = async () => {
  let email = '';
  const cognitouser = await getCognitouser(router.currentRoute.value.params.sub);
  if(cognitouser) {
    email = cognitouser.findAttributeValue('email');
    const newuser: User = new User({email: email});
    const u: User = await store.dispatch('usermanagement/addUser', newuser);
    setUser(u);
  }
}

const save = () => {
  saveUser(user.value)
  .then(() => toasted.success("Saved"));
}

const back = () => {
  router.back();
}


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: "fas fa-arrow-left fa-2x",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (user.value.name)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(user.value.name), 1))
          : (user.value.email)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(user.value.email), 1))
            : (_openBlock(), _createElementBlock("h1", _hoisted_7, "New user"))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.name) = $event)),
                type: "text",
                class: "form-control"
              }, null, 512), [
                [_vModelText, user.value.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_multiselect_text, {
                modelValue: _ctx.customers,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customers) = $event)),
                options: _ctx.reportTypes,
                "allow-empty": true,
                taggable: false,
                "custom-label": _ctx.formatReportType,
                multiple: "",
                onSelect: _ctx.onSelectReporttype,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editTemplate('type', $event)))
              }, null, 8, ["modelValue", "options", "custom-label", "onSelect"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: user.value.email,
                disabled: ""
              }, null, 8, _hoisted_18)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", {
              class: "col-sm-9 body-editor",
              height: messageheight.value
            }, [
              _createVNode(_component_ckeditor, {
                editor: signatureeditor.value,
                modelValue: signatureeditordata.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((signatureeditordata).value = $event)),
                config: signatureEditorConfig.value
              }, null, 8, ["editor", "modelValue", "config"])
            ], 8, _hoisted_21)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                onClick: _withModifiers(save, ["prevent"])
              }, "Save")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})